<template>
  <y-block-box title="激活申请">
    <template #suffix>
      <div style="display: flex">
<!--        <el-button type="primary" plain size="small" icon="el-icon-edit" @click="templateEdit('serialNum')">序列号模板</el-button>-->
<!--        <el-button type="warning" plain size="small" icon="el-icon-edit" @click="templateEdit('download')">下载链接模板</el-button>-->
        <el-button type="success" plain size="small" icon="el-icon-upload2" @click="exportToExcel()">导出当页 Excel</el-button>
      </div>
    </template>
    <div class="main-box">
      <div style="flex: 1;overflow:auto;padding: 0px 16px;">
        <el-table :data="tableData" v-loading="loadingData" style="width: 100%" empty-text='暂无数据'>
          <!-- 拓展信息 -->
          <el-table-column type="expand" width="48">
            <template slot-scope="props">
              <div v-if="props.row.from === 'wechat'" class="expand-contain">
                <div style="grid-column-start: span 2;font-weight: bold;">
                  用户信息
                </div>
                <div class="title">姓名</div>
                <div class="label">{{ props.row.name }}</div>
                <div style="grid-column-start: span 2;font-weight: bold;">
                  微信详情
                </div>
                <div class="title">群聊名称</div>
                <div class="label">{{ props.row.subject }}</div>
                <div class="title">微信消息</div>
                <div class="label">{{ props.row.content }}</div>
              </div>
              <div v-else-if="props.row.from === 'weapp'" class="expand-contain">
                <div style="grid-column-start: span 2;font-weight: bold;">
                  用户信息
                </div>
                <div class="title">姓名</div>
                <div class="label">{{ props.row.name }}</div>
                <div class="title">团队/单位</div>
                <div class="label">{{ props.row.team }}</div>
                <div style="grid-column-start: span 2;font-weight: bold;">
                  微信详情
                </div>
                <div class="title">录入人</div>
                <div class="label">{{ props.row.createdBy }}</div>
                <div class="title">微信消息</div>
                <div class="label">{{ props.row.content }}</div>
              </div>
              <div v-else-if="props.row.from !== 'wechat'" class="expand-contain">
                <div style="grid-column-start: span 2;font-weight: bold;">
                  用户信息
                </div>
                <div class="title">姓名</div>
                <div class="label">{{ props.row.name }}</div>
                <div class="title">团队/单位</div>
                <div class="label">{{ props.row.team }}</div>
                <div class="title">联系方式</div>
                <div class="label">{{ props.row.contact }}</div>
                <div class="title">了解渠道</div>
                <div class="label">{{ props.row.channel }}</div>
                <div style="grid-column-start: span 2;font-weight: bold;">
                  软件下载与激活
                </div>
                <div class="title">计算机 ID</div>
                <div class="label">{{ props.row.computerID }}</div>
                <div class="title">接收邮箱</div>
                <div class="label">{{ props.row.email }}</div>
              </div>
              <div v-if="props.row.from && props.row.from.includes('email')" class="expand-contain">
                <div style="grid-column-start: span 2;font-weight: bold;">
                  邮件详情
                </div>
                <div class="title">邮件主题</div>
                <div class="label">{{ props.row.subject }}</div>
                <div class="title">邮件正文</div>
                <div class="label">{{ props.row.content }}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="status" label="状态" :filter-method="filterTag" sortable filter-placement="bottom-end"
                           width="90px" :filters="statusType">
            <template slot-scope="scope">
              <el-tag :type="statusDic[scope.row.status].colorType" disable-transitions>
                {{ statusDic[scope.row.status].text }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="team" label="团队/单位" sortable></el-table-column>
          <el-table-column prop="name" label="姓名" sortable width="80px"></el-table-column>
          <el-table-column prop="contact" label="联系方式" sortable></el-table-column>
          <el-table-column prop="email" label="邮箱" sortable></el-table-column>
          <el-table-column prop="from" label="来源" sortable width="100px"></el-table-column>
          <el-table-column prop="createdAtLocal" label="创建时间" sortable>
            <template slot-scope="scope">
              <i class="el-icon-time"></i>
              {{ new Date(scope.row.createdAt).toLocaleString() }}
            </template>
          </el-table-column>
          <el-table-column prop="createdBy" label="录入人" sortable width="90px"></el-table-column>

        </el-table>
      </div>
      <div style="display: flex;justify-content: right;padding: 0px 16px;">
        <el-pagination @size-change="fnQuery" @current-change="fnQuery" :current-page.sync="currentPage"
                       :page-sizes="[10, 50, 100, 500, 1000, 10000]" :page-size.sync="pageSize" layout="total, sizes, prev, pager, next, jumper"
                       :total="tableTotal">
        </el-pagination>
      </div>
      <el-dialog title="模板编辑" destroy-on-close :visible.sync="templateEditVisible" width="50%" center>
        <template-edit :editType="editType"></template-edit>
      </el-dialog>
    </div>
  </y-block-box>
</template>


<script>
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import templateEdit from './templateEdit.vue';
export default {
  name: 'index',
  components: { templateEdit },
  props: {},
  data() {
    const statusType = [
      { text: '未发送', value: 0, colorType: "warning" },
      { text: '已发送', value: 1, colorType: "success" },
      { text: '发送失败', value: 2, colorType: "error" },
    ]
    let statusDic = {}
    statusType.forEach(item => {
      statusDic[item.value] = {
        text: item.text,
        colorType: item.colorType
      }
    })
    return {
      statusType,
      statusDic,
      pageSize: 10,
      tableData: [],
      tableTotal: 0,
      currentPage: 1,
      templateEditVisible: false,
      editType: '',
      loadingData: false
    }
  },
  mounted() {
    this.fnQuery()
  },
  methods: {
    async exportToExcel() {

      // Excel表数据
      const excelData = [
        ["了解渠道", "计算机ID", "联系方式", "邮箱", "姓名", "团队/单位", "创建时间", "来源", "录入人", "邮件主题、群聊名称", "邮件正文/微信消息", "状态"],
        ...this.tableData.map(obj => [
          obj.channel ? obj.channel.toString() : '',
          obj.computerID ? obj.computerID.toString() : '',
          obj.contact ? obj.contact.toString() : '',
          obj.email ? obj.email.toString() : '',
          obj.name ? obj.name.toString() : '',
          obj.team ? obj.team.toString() : '',
          obj.createdAt ? new Date(obj.createdAt).toLocaleString() : '',
          obj.from ? obj.from.toString() : '',
          obj.createdBy ? obj.createdBy.toString() : '',
          obj.subject ? obj.subject.toString() : '',
          obj.content ? obj.content.toString() : '',
          this.statusDic[obj.status].text,
        ])
      ]

      console.log('excelData', excelData)

      // 将数据转换为工作表
      const worksheet = XLSX.utils.aoa_to_sheet(excelData);

      // 创建工作簿并添加工作表
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'ATK 申请');

      // 生成Excel文件
      const excelBuffer = await XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });

      // 使用blob和FileReader创建一个Blob URL
      const dataBlob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
      const blobUrl = window.URL.createObjectURL(dataBlob);

      // 使用saveAs下载文件
      const currentDate = Date.now()
      saveAs(dataBlob, `ATK-${currentDate}.xlsx`);

      // 清理
      window.URL.revokeObjectURL(blobUrl);
    },
    async fnQuery() {
      this.loadingData = true
      this.$callApi("queryTrialByPage", {
        pageSize: this.pageSize,
        currentPage: this.currentPage
      }, { method: "post" }).then(res => {
        this.tableData = res.list.map((i) => {
          let date = new Date(i.createdAt);
          date.setMilliseconds(date.getMilliseconds() + 8 * 3600e3);
          i.createdAtLocal = date.toISOString();
          return i;
        });
        this.tableTotal = res.total
        this.loadingData = false;
      })
        .catch(e => {
          this.$message.error(e.message || "请求失败");
          this.loadingData = false;
        });
    },
    filterTag(value, row) {
      return row.status === value;
    },
    templateEdit(type) {
      this.templateEditVisible = true
      this.editType = type
      console.log('type', type)
    }
  },
}
</script>
<style lang="less" scoped>
.main-box {
  display: flex;
  flex-direction: column;
  gap: 6px;
  overflow: auto;
  height: 100%;
}

.expand-contain {
  display: grid;
  grid-template-columns: 80px 1fr;
  margin-left: 48px;

  div {
    line-height: 40px;
  }

  .title {
    color: #99a9bf;
  }

  .title::after {
    content: '：';
  }

  .label:empty::after {
    content: '--';
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/index/index.vue